import { useQuery } from "@tanstack/react-query";
import { fetchFirmDashboard, type FirmDashboardFeed } from "../api/firmDashboard";

export function useFirmDashboard() {
  return useQuery<FirmDashboardFeed>({
    queryKey: ["firm", "dashboard"],
    queryFn: fetchFirmDashboard,
    staleTime: 60_000,
  });
}
